import { render, staticRenderFns } from "./buscarVentasModal.vue?vue&type=template&id=2ccad4f2&"
import script from "./buscarVentasModal.vue?vue&type=script&lang=js&"
export * from "./buscarVentasModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QSelect,QBtn,QTooltip,QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QSelect,QBtn,QTooltip,QTable,QTd})
